import { render, staticRenderFns } from "./ItemAutocomplete.vue?vue&type=template&id=6ca2a68e&scoped=true&"
import script from "./ItemAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ItemAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./ItemAutocomplete.vue?vue&type=style&index=0&id=6ca2a68e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca2a68e",
  null
  
)

export default component.exports